import React from "react";

import { WSModalOldProvider } from "../components/common/WSModalOld/WSModalOldContext";
import { UseWSModalProvider } from "../components/WSModal/WSModal.context";
import { WSSnackbarProvider } from "../components/WSSnackbar/WSSnackbar.component";

export const WSProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => (
  <WSSnackbarProvider>
    <WSModalOldProvider>
      <UseWSModalProvider>{children}</UseWSModalProvider>
    </WSModalOldProvider>
  </WSSnackbarProvider>
);
